<template>
  <div class="card commodity-info">
    <div class="info">
      <div class="info-header">物流方式</div>
      <!-- <div class="info-header">物流信息</div> -->
      <van-row class="info-line">
        <van-col :span="12">
          <span class="info-title">交货方式：</span>
          <span class="info-value">自提</span>
        </van-col>
        <van-col :span="12">
          <span class="info-title">接收站/液化厂：</span>
          <span class="info-value">{{listingDetail.stationName}}</span>
        </van-col>
      </van-row>
      <van-row class="info-line">
        <van-col :span="12">
          <span class="info-title">联 系 人 ：</span>
          <span class="info-value">{{listingDetail.stationContactName}}</span>
        </van-col>
        <van-col :span="12">
          <span class="info-title">联系电话：</span>
          <span class="info-value">{{listingDetail.stationContactPhone}}</span>
        </van-col>
      </van-row>
      <van-row class="info-line">
        <span class="info-title">地 址：</span>
        <span class="info-value">{{listingDetail.stationAddress}}</span>
      </van-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderLogisticsCard",
  props: {
    listingDetail: Object,
  },
  data() {
    return {};
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.card {
  margin-top: 24px;
  background: #ffffff;
  padding: 0 24px;
  font-size: 26px;

  .info {
    padding: 16px 0;

    .info-header {
      display: flex;
      justify-content: right;
      align-items: center;
      height: 88px;
      font-size: 32px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }
    }

    .info-line {
      line-height: 54px;
      color: #666666;
    }
  }
}
</style>